// extracted by mini-css-extract-plugin
export default {"container":"nj-z","links":"oj-z"};